<!--
 * @Author: your name
 * @Date: 2021-04-13 13:55:31
 * @LastEditTime: 2021-04-16 09:27:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/views/user/receipt/TitleList.vue
-->

<template>
  <Nav-bar title="选择发票抬头" right_text="新增"></Nav-bar>
  <div class="top-margin"></div>
  <div class="contaienr">
    <van-list
      v-if="state.titleList.length != 0"
      v-model:loading="state.loading"
      :finished="state.finished"
    >
      <div v-for="item in state.titleList" :key="item" @click="toAffirm(item)">
        <van-swipe-cell
          :before-close="beforeClose"
          :stop-propagation="true"
          :name="item.id"
          :ref="swipeCell"
        >
          <div class="item-container">
            <div class="item-v display_flex">
              <img :src="item.typeIcon" class="title-icon" />
              <div class="m-l-15">
                <span class="t-f14-c1a font-bold">{{ item.title }}</span>
                <div class="t-f12-c99">{{item.title_type =='company'?'企业':'个人'}}电子发票</div>
              </div>
            </div>
          </div>
          <template #right>
            <div class="delete-container">
              <span class="t-f14-cff font-bold">删除</span>
            </div>
          </template>
        </van-swipe-cell>
      </div>
    </van-list>
    <van-empty description="暂无抬头信息" v-else>
      <van-button
        round
        type="danger"
        class="bottom-button font-bold"
        @click="createReceiptTitle"
        >新增抬头</van-button
      >
    </van-empty>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import request from "@/api/request";
import { reactive, ref } from "vue";
import httpHelper from "@/helpers/http_helper";
import { useRouter } from "vue-router";
import { Dialog, Toast } from "vant";
import { useStore } from "vuex";
let router;
let storeContext;
let state = reactive({
  titleList: [],
  finished: false,
  loading: false,
});
let that;
let swipeCell;
// 存储dom数组
let myRef = ref([]);
export default {
  components: {
    NavBar,
  },
  created() {
    that = this;
    this.requestTitleList();
  },
  mounted() {
    //  this.$refs.swipeCell.toggle();
  },
  setup() {
    router = useRouter();
    storeContext = useStore();

    swipeCell = (el) => {
      myRef.value.push(el);
    };
    return { state, createReceiptTitle, beforeClose, swipeCell, toAffirm };
  },

  methods: {
    requestTitleList() {
      httpHelper.showLoading();
      request
        .getTitleList()
        .then((res) => {
          state.loading = false;
          httpHelper.hideLoading();
          state.finished = true;
          state.titleList = formatTitleTypeIcon(res.data.results)
        })
        .catch(() => {
          httpHelper.hideLoading();
        });
    },
  },
};
function formatTitleTypeIcon(array){
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    element.typeIcon = element.title_type =='company'? require('@/images/invoice_company_title.png'):require('@/images/invoice_person_title.png')
  }
  return array
}
function beforeClose({ position, name }) {
  if (position == "right") {
    Dialog.confirm({
      title: "确定删除吗？",
    })
      .then(() => {
        deleteTitle(name);
      })
      .catch(() => {
        swipeCellCloseAll(myRef.value);
      });
  }
}
function swipeCellCloseAll(list) {
  for (let index = 0; index < list.length; index++) {
    const element = list[index];
    element.close();
  }
}
function deleteTitle(id) {
  request.deleteInvoices(id).then(() => {
    Toast("删除成功!");

    that.requestTitleList();
  });
}
//确认开票
function toAffirm(item) {
  // if history router is container 
  if (router.options.history.state.back != "/user/receipt/container") {
    let invoicesData = storeContext.state.invoicesData;
    let mergeData = Object.assign(invoicesData, { titleInfo: item });
    storeContext.commit("setInvoices", mergeData);
    router.push("/user/receipt/affirm");
  }else{
     //defult router to invoice title details
     router.push({name:'TitleEditor',params:{id:item.id}})

  }
}
function createReceiptTitle() {
  router.push("/user/receipt/title_editor");
}
</script>

<style scoped lang="scss">
.bottom-button {
  width: 160px;
  height: 40px;
}
.delete-container {
  height: 60px;
  width: 100px;
  background: red;
  text-align: center;
  line-height: 60px;
  align-items: center;
}
.title-icon {
  width: 36px;
  height: 36px;
}
.item-v {
  border-top: 1px solid #ebebeb;
  align-items: center;
  height: 60px;
}
.item-container {
  background: #fff;
  padding-left: 15px;
}
</style>